const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoCsv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-csv"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2645",
    "data-name": "Grupo 2645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1293",
    "data-name": "Caminho 1293",
    d: "M4.17,50H35.83A4.17,4.17,0,0,0,40,45.83v-35a.87.87,0,0,0-.24-.59l-10-10A.87.87,0,0,0,29.17,0h-25A4.17,4.17,0,0,0,0,4.17V45.83A4.17,4.17,0,0,0,4.17,50ZM30,2.85,37.15,10H32.5A2.5,2.5,0,0,1,30,7.5ZM1.67,4.17a2.5,2.5,0,0,1,2.5-2.5H28.33V7.5a4.19,4.19,0,0,0,4.17,4.17h5.83V45.83a2.5,2.5,0,0,1-2.5,2.5H4.17a2.5,2.5,0,0,1-2.5-2.5Z",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1305",
    "data-name": "Caminho 1305",
    d: "M5.83,11.67h10a.85.85,0,0,0,.87-.81.84.84,0,0,0-.81-.86H5.83a.84.84,0,0,0,0,1.67Z",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1298",
    "data-name": "Caminho 1298",
    d: "M5.83,16.67h5a.85.85,0,0,0,.87-.81.84.84,0,0,0-.81-.86H5.83a.84.84,0,0,0,0,1.67Z",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1294",
    "data-name": "Caminho 1294",
    d: "M13.33,15.83a.85.85,0,0,0,.84.84h20a.84.84,0,0,0,0-1.67h-20a.84.84,0,0,0-.84.83Z",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1295",
    "data-name": "Caminho 1295",
    d: "M5.83,21.67H22.5a.84.84,0,0,0,0-1.67H5.83a.84.84,0,0,0,0,1.67Z",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1299",
    "data-name": "Caminho 1299",
    d: "M34.17,20H25.83a.84.84,0,0,0,0,1.67h8.34a.84.84,0,0,0,0-1.67Z",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1300",
    "data-name": "Caminho 1300",
    d: "M5.83,26.67h10a.85.85,0,0,0,.84-.84.84.84,0,0,0-.84-.83h-10a.83.83,0,0,0-.83.83A.84.84,0,0,0,5.83,26.67Z",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1296",
    "data-name": "Caminho 1296",
    d: "M34.17,25h-15a.84.84,0,0,0-.84.83.85.85,0,0,0,.84.84h15a.84.84,0,0,0,.83-.84.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1297",
    "data-name": "Caminho 1297",
    d: "M5.83,31.67h20a.85.85,0,0,0,.84-.84.84.84,0,0,0-.84-.83h-20a.83.83,0,0,0-.83.83.84.84,0,0,0,.83.84Z",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1301",
    "data-name": "Caminho 1301",
    d: "M34.17,30h-5a.84.84,0,0,0-.84.83.85.85,0,0,0,.84.84h5a.84.84,0,0,0,.83-.84A.83.83,0,0,0,34.17,30Z",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1304",
    "data-name": "Caminho 1304",
    d: "M5.83,36.67H12.5a.84.84,0,0,0,.83-.84A.83.83,0,0,0,12.5,35H5.83a.83.83,0,0,0-.83.83.84.84,0,0,0,.83.84Z",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1306",
    "data-name": "Caminho 1306",
    d: "M25,35.83a.83.83,0,0,0-.83-.83H15.83a.83.83,0,0,0-.83.83.84.84,0,0,0,.83.84h8.34a.84.84,0,0,0,.83-.84Z",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1307",
    "data-name": "Caminho 1307",
    d: "M34.17,35H27.5a.83.83,0,0,0-.83.83.84.84,0,0,0,.83.84h6.67a.84.84,0,0,0,.83-.84A.83.83,0,0,0,34.17,35Z",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1303",
    "data-name": "Caminho 1303",
    d: "M5.83,41.67h10a.85.85,0,0,0,.84-.84.84.84,0,0,0-.84-.83h-10a.83.83,0,0,0-.83.83A.84.84,0,0,0,5.83,41.67Z",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1302",
    "data-name": "Caminho 1302",
    d: "M27.5,40H19.17a.84.84,0,0,0-.84.83.85.85,0,0,0,.84.84H27.5a.84.84,0,0,0,.83-.84A.83.83,0,0,0,27.5,40Z",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1308",
    "data-name": "Caminho 1308",
    d: "M34.17,40H30.83a.83.83,0,0,0-.83.83.84.84,0,0,0,.83.84h3.34a.84.84,0,0,0,.83-.84A.83.83,0,0,0,34.17,40Z",
    style: {
      fill: "#404040"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCsv);
export default __webpack_public_path__ + "static/media/ico-csv.1c5a1243cfb5deb3974293df4176664a.svg";
export { ForwardRef as ReactComponent };